<div class="main-box">
    <div class="left-sub-box">
        <div class="left-sub-container">
            <div class="post-nav-container">
                <div style="width: 20px; height: 20px; left: 0px;position: absolute">
                    <img src="assets/post-icon.svg">
                </div>
                <div *ngIf="hasPostHubAccess"
                    style="width: 5%; height: 30px; left: 245px; position: absolute; transform-origin: 0 0; border: 3px #386AF6 solid">
                </div>
                <div class="left-item-text">Posts Hub
                </div>
            </div>
            <div style="width: 246.13px; height: 0px; border: 0.50px #ECECEC solid"></div>
            <div style="width: 172.92px; height: 19.03px; position: relative"
                routerLink="/admin/social-hub/competition-zone">
                <!-- <div style="width: 3%; height: 30px; left: 245px; position: absolute; transform-origin: 0 0; border: 3px #386AF6 solid"></div> -->
                <div class="left-item-text"> Competitions Hub</div>
                <img src="assets/competition-icon.svg">
            </div>
            <div style="width: 246.13px; height: 0px; border: 0.50px #ECECEC solid"></div>
        </div>
    </div>
    <div *ngIf="!hasPostHubAccess" class="no-access-message" fxLayout="column" fxLayoutAlign="center center">
        <h3>Access Restricted</h3>
        <p>You don't have permission to access the Post Hub.</p>
    </div>
    <div *ngIf="hasPostHubAccess" class="right-sub-box">
        <div style="width: 923.87px; justify-content: space-between; align-items: flex-start; gap: 12px; display: inline-flex">
            <div fxLayout="row" style="gap: 10px;">
                <button class="fillter-button" style="background: #E3ECFB; width: 99px;" [ngStyle] ="{'background':postListType === 'Published' ? '#E3ECFB' : 'white'}">
                    <div class="fillter-button-text" (click)="changePostListType(1)">Published</div>
                </button>
                <button class="fillter-button" style="background: #E3ECFB; width: 99px;" [ngStyle] ="{'background':postListType === 'Scheduled' ? '#E3ECFB' : 'white'}" >
                    <div class="fillter-button-text" (click)="changePostListType(2)">Schedule</div>
                </button>
            </div>
            <div fxLayout="row" style="gap: 10px;">
                <button class="fillter-button" style="background:#386AF6;" routerLink="/admin/social-hub/create-post/new/true">
                    <div
                        style="color: #FFF; font-size: 12px; font-family: Montserrat; font-weight: 500; letter-spacing: 0.24px; word-wrap: break-word">
                        <img src="assets/plus-icon.svg">
                        Schedule Post
                    </div>
                </button>
                <button class="fillter-button" style="background:#386AF6;" routerLink="/admin/social-hub/create-post/new/false">
                    <div
                        style="color: #FFF; font-size: 12px; font-family: Montserrat; font-weight: 500; letter-spacing: 0.24px; word-wrap: break-word">
                        <img src="assets/plus-icon.svg">
                        Create New Post
                    </div>
                </button>
            </div>

        </div>
        <div style="position: relative; margin-left: auto; width: 241px; height: 52px; border: 1px solid grey; border-radius: 8px;">
            <div style="display: flex; align-items: center;">
                <div style="display: flex; flex-direction: column; align-items: start; margin-left: 12px; justify-content: center;">
                    <p style="font-size: 12px; margin: 0; padding-top: 8px; color: #999999;">Showing posts published by</p>
                    <p style="font-size: 14px; margin: 0; padding: 0;">{{selectedOwner}}</p>
                </div>
                <mat-icon *ngIf="!ownerDropDown" style="color: #386AF6; margin-left: auto; margin-top: 5px;" fxLayoutAlign="end" (click)="toggleOwnerDropDown()">keyboard_arrow_down</mat-icon>
                <mat-icon  *ngIf="ownerDropDown" style="color: #386AF6; margin-left: auto; margin-top: 5px;" fxLayoutAlign="end" (click)="toggleOwnerDropDown()">keyboard_arrow_up</mat-icon>
            </div>
            <div *ngIf="ownerDropDown" style="position: absolute; margin-top: 5px; top: 100%; left: 0; width: 100%; overflow: auto; max-height: 40vh; z-index: 999; display: flex; flex-direction: column; background-color: white; border-radius: 10px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);">
                <button *ngFor="let owner of allPostsOwners; let i = index;" 
                    style="font-size: 12px; border: none; background: none; padding: 10px 20px; text-align: left; cursor: pointer;"
                    class="py-2" (click)="onOwnerSelect(owner)">
                    {{owner.name}}
                </button>
                <button *ngIf="selectedOwner !== 'All'" 
                        style="font-size: 12px; font-weight: 700; border: none; background: none; padding: 10px 20px; text-align: left; cursor: pointer;" 
                        class="py-2" (click)="onOwnerRemove()">
                       Remove Owner
                </button>
            </div>
        </div>
        <div fxLayout="row"  style="gap: 10px; align-items: center; position: relative;">
            <div
                style="width: 25%;padding: 10px; height: 45px; background: white;border-radius: 8px;border: 1px #ECECEC solid; display: flex;align-items: center;">
                <mat-icon [ngStyle]="{'color':'#386AF6'}" matSuffix>search</mat-icon>
                <input style="border: none;outline: none;" matInput placeholder="Search by typing here..."
                    (input)="triggerSearchFunction()" [(ngModel)]="searchValue">
            </div>
            <mat-form-field appearance="standard" class="custom-mat-form-field">
                <button class="btn mx-1 filter-btn col-md-3"
                    style="display:inline-flex;justify-content: center;width: 80%" id="reportrange" type="button"
                    (click)="picker.open()">
                    <div style="display: flex; gap: 10px;" *ngIf="startFilterDate==''">
                        <img src="assets/calender.svg">
                        <span style="color: #386AF6; font-size: 14px; font-family: Montserrat;">From</span>
                    </div>
                    <span *ngIf="startFilterDate!=''">{{startFilterDate | dateTransform : 'std'}}</span>
                </button>
                <input [(ngModel)]="startFilterDate" (dateChange)="onFilterStartDateChange($event)" matInput
                    [matDatepicker]="picker" [max] = "today" hidden>
                <mat-datepicker-toggle matIconSuffix [for]="picker" hidden></mat-datepicker-toggle>
                <mat-datepicker #picker hidden></mat-datepicker>
            </mat-form-field>
            <div style="width: 1%; height: 100%; border: 1px #999999 solid"></div>
            <mat-form-field appearance="standard" class="custom-mat-form-field">
                <button class="btn mx-1 filter-btn col-md-3"
                    style="display:inline-flex;justify-content: center;width: 80%" id="reportrange" type="button"
                    (click)="picker1.open()">
                    <div style="display: flex; gap: 10px;" *ngIf="endFilterDate==''">
                        <img src="assets/calender.svg">
                        <span style="color: #386AF6; font-size: 14px; font-family: Montserrat;">To</span>
                    </div>
                    <span *ngIf="endFilterDate!=''">{{endFilterDate | dateTransform : 'std'}}</span>
                </button>
                <input [(ngModel)]="endFilterDate" (dateChange)="onFilterEndDateChange($event)" matInput
                    [matDatepicker]="picker1" [max] = "today" hidden>
                <mat-datepicker-toggle matIconSuffix [for]="picker1" hidden></mat-datepicker-toggle>
                <mat-datepicker #picker1 hidden></mat-datepicker>
            </mat-form-field>
            <div style="width: 15%; position: relative; height: 45px; border: 1px #ECECEC solid; display: flex; align-items: center; justify-content: center; border-radius: 10px;">
                <button type="button" style="border: none; background: none;" (click)="toggleFilterDropdown()">
                    <div fxLayout="row">
                        <span style="width: 100%; font-size: 12px; font-family: Montserrat; font-weight: 510; letter-spacing: 0.28px; white-space: nowrap;">
                            {{selectedFilter}}
                        </span>
                    </div>                    
                </button>
                <div *ngIf="isDropdownVisible" 
                     style="position: absolute; top: 100%; left: 0; width: 100%; overflow: auto; max-height: 40vh; z-index: 999; display: flex; flex-direction: column; background-color: white; border-radius: 10px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);">
                    <button *ngFor="let type of uniquePostTypes; let i = index;" 
                            style="font-size: 12px; border: none; background: none; padding: 10px 20px; text-align: left; cursor: pointer;"
                            class="py-2" (click)="onFilterSelect(type)">
                        {{type}}
                    </button>
                    <button *ngIf="selectedFilter !== 'Post type'" 
                            style="font-size: 12px; font-weight: 700; border: none; background: none; padding: 10px 20px; text-align: left; cursor: pointer;" 
                            class="py-2" (click)="onRemoveFilter()">
                        Remove filter
                    </button>
                </div>
                <mat-icon *ngIf="!isDropdownVisible" style="color: #386AF6;" fxLayoutAlign="end" (click)="toggleFilterDropdown()">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="isDropdownVisible" style="color: #386AF6;" fxLayoutAlign="end" (click)="toggleFilterDropdown()">keyboard_arrow_up</mat-icon>
            </div>
            <button mat-button color="primary" (click)="resetFilter()">Reset</button>
            <button style="display: flex; position: absolute; align-items: center; justify-content: center; gap: 10px; border-radius: 99px; padding: 14px 24px; border: 1px solid #386AF6; background-color: white; right: 2px;" (click)="downloadCSV()">
                <p style="font-size: 13px; color: #386AF6; margin: 0;">Download</p>
                <img src="assets/csv-icon.svg" alt="csv-icon" />
            </button>
            
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div [fxFlex]="postListType === 'Published' ? '60%' : '35%'"  class="text-center">
                <span class="table-header-text">Title</span>
            </div>
            <div fxFlex="15%" class="text-center">
                <span class="table-header-text" *ngIf="postListType === 'Published'">Date Published</span>
                <span class="table-header-text" *ngIf="postListType === 'Scheduled'">Schedule Date</span>
                <img [src]="sortIconStartTimeSrc" class="arrow-icon" (click)="sortAccToStartTime()">

            </div>
            <div fxFlex="15%" class="text-center" *ngIf="postListType === 'Published'">
                <span class="table-header-text">Reactions</span>
                <img [src]="sortIconReactionSrc" class="arrow-icon" (click)="sortAccToReatctions()">
            </div>
            <div fxFlex="8%" class="text-center" *ngIf="postListType === 'Published'">
                <span class="table-header-text">Posts link</span>
            </div>
            <div fxFlex="35%" class="text-center" style="margin-left: 30px;" *ngIf="postListType === 'Published'">
                <span class="table-header-text">Posted From</span>
            </div>
            <div fxFlex="5%" class="text-center">
               
            </div>
        </div>
        <div *ngFor="let post of allPosts" class="table-item">
            <div fxLayout="row" fxLayoutAlign="space-between center table-text-item">
                <div [fxFlex]="postListType === 'Published' ? '60%' : '35%'"  class="text-center table-text-item" style="padding-left: 5px;">
                    <div
                        style="padding: 15px 10px; width: 100%; height: 100%; background: white; border-radius: 8px; justify-content: space-between; align-items: center; gap: 6px; display: inline-flex; word-break: break-word;">
                        <img *ngIf="post.type =='question' || post.type =='poll'" src="assets/poll.svg">
                        <img *ngIf="post.type !='question' && post.type !='poll'" src="assets/image-icon.svg">
                        <div *ngIf="post?.content && post?.content.length <= 70" [innerHTML]="post?.content" ></div>
                        <div *ngIf="post?.content && post?.content.length > 70"
                            [innerHTML]="post?.content.substring(0,70)+'...'"  style="word-break: break-all;"></div>
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="duplicatePost(post.post_id)">
                                <span>Duplicate</span>
                            </button>
                            <button mat-menu-item (click)="deletePost(post.post_id)">
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
                <div fxFlex="15%" class="text-center table-text-item" *ngIf="postListType === 'Published'">
                    {{post?.created_at | dateTransform: 'std' }}
                </div>
                <div fxFlex="15%" class="text-center table-text-item" *ngIf="postListType === 'Scheduled'">
                    {{post?.scheduled_time | dateTransform: 'std' }}
                </div>
                <div fxFlex="15%" class="text-center table-text-item" *ngIf="postListType === 'Published'">
                    {{post.totalReaction}}
                </div>
                <div *ngIf="postListType === 'Published'" fxFlex="8%">
                    <img src="assets/copy-icon.svg" alt="copy" />
                    <button style="margin-left: 5px; padding: 0;" tooltip="Copied to clipboard"  (mouseleave)="toolTip.hide()" triggers="" #toolTip="bs-tooltip"   placement="bottom" type="button" [matRippleCentered]="true" matRipple   class="copypost-btn" ngxClipboard (click)="toolTip.show()" [cbContent]="getPostLink(post.post_id)">Copy</button>
                </div>
                <div fxFlex="35%" class="text-center table-text-item" style="margin-left: 30px;" *ngIf="postListType === 'Published'">
                    <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                        <div style="display: flex; height: 40px; width: 40px; border-radius: 100%; overflow: hidden;">
                            <img src={{post.author.photo}} alt="photo" style="width: 100%; height: 100%; object-fit: contain;" />
                        </div>
                        <div>{{post.author.name}}</div>
                    </div>
                </div>
                <div fxFlex="5%" class="text-center" style="display: flex;justify-content: flex-end;">
                    <img src="assets/angle.svg" style="cursor: pointer;"
                        routerLink="/admin/social-hub/post-detail/{{post.post_id}}/{{postListType}}">
                </div>
            </div>
        </div>
        <div *ngIf="allPosts.length === 0" style="display: flex; align-items: center; justify-content: center;">
            <p>No matching posts found</p>
        </div>
        <div class="pagination" *ngIf="totalItems > limit">
            <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">Previous</button>
            <button (click)="goToPage(1)" [class.active]="currentPage === 1">1</button>
            <span *ngIf="currentPage > 2">...</span>
            <button 
              *ngFor="let page of visiblePages.slice(1, visiblePages.length - 1)" 
              (click)="goToPage(page)" 
              [class.active]="currentPage === page">
              {{ page }}
            </button>
            <button *ngIf="currentPage <= totalPages" (click)="goToPage(totalPages)" [class.active]="currentPage === totalPages">
              {{ totalPages }}
            </button>
            <span *ngIf="currentPage < totalPages">...</span>
            <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">Next</button>
        </div>
</div>